import React, { useState, useEffect } from "react";
import AboutHelp from "./helpers/about";
import Navbar from "../layouts/nav";

export default function About(){

	useEffect(() => {
		// List of JS files to reload
		const jsFiles = [
		  'assets/js/custom.js',
		];
	
		// Create script elements for each JS file
		jsFiles.forEach((filePath) => {
		  const script = document.createElement('script');
		  script.src = filePath;
		  script.async = true;
		  document.body.appendChild(script);
		});
	
		// Clean up the script elements when the component unmounts
		return () => {
		  jsFiles.forEach((filePath) => {
			const script = document.querySelector(`[src="${filePath}"]`);
			if (script) {
			  document.body.removeChild(script);
			}
		  });
		};
	  }, []);

	


	const [isPlaying, setIsPlaying] = useState(false);
	const [pause, setPause] = useState(0);
  	const audioRef = React.createRef();

  	const toggleAudio = (e) => {
    	if (isPlaying) {
		setPause(e.target.classList.add('about_paused'));
      	audioRef.current.pause();
    	} else {
		setPause(e.target.classList.remove('about_paused'));
      	audioRef.current.play();
    	}
    	setIsPlaying(!isPlaying);
	};



		useEffect(() => {
			const videoElements = document.querySelectorAll(".lazy-video");
		
			const options = {
			  root: null,
			  rootMargin: "0px",
			  threshold: 0.1,
			};
		
			const handleIntersection = (entries, observer) => {
			  entries.forEach((entry) => {
				if (entry.isIntersecting) {
				  const video = entry.target;
				  video.src = video.dataset.src;
				  observer.unobserve(video);
				}
			  });
			};
		
			const observer = new IntersectionObserver(handleIntersection, options);
		
			videoElements.forEach((video) => {
			  observer.observe(video);
			});
		
			return () => {
			  observer.disconnect();
			};
		  }, []);
    return(
        <>

	<Navbar transparent={"transparent"} active={"about"}></Navbar>

	<div className="about_body">
		<div className="about_container">
			<section className="about_gallery">
				<div className="about_frame">
					<div className="about_frame__content">
						<h2 className="about_h2" style={{color: 'white'}}>BioUniverse</h2>
					</div>
				</div>
				<div className="about_frame">
					<div className="about_frame__content">
						<img
                  className="about_frame-media about_frame-media_left"
                  src="assets/AboutUs/images/1.webp"
                  alt="Alt"
                  loading="lazy"
                />
					</div>
				</div>
				<div className="about_frame about_frame_bg">
					<div className="about_frame__content">
						<video
                  className="about_frame-media about_frame-media_right lazy-video"
                  data-src="assets/AboutUs/media/video_optimized.mp4"
                  autoPlay
                  loop
                  muted
                ></video>
					</div>
				</div>
				<div className="about_frame"></div>
				<div className="about_frame">
					<div className="about_frame__content about_text-right">
						<h3 className="about_h3" style={{color: 'white'}}>Wild Wonders</h3>
						<p style={{fontSize: '2rem', color: 'gray'}}>Explore Earth's diverse creatures and their habitats in this animal encyclopedia</p>
					</div>
				</div>
				<div className="about_frame about_frame_bg">
					<div className="about_frame__content">
						<div className="about_frame-media about_frame-media_left" style={{backgroundImage: "url(assets/AboutUs/images/2.webp)"}}></div>
					</div>
				</div>
				<div className="about_frame"></div>
				<div className="about_frame about_frame_bg">
					<div className="about_frame__content">
						<div className="about_frame-media about_frame-media_right" style={{backgroundImage: "url(https://images.unsplash.com/photo-1508625935447-e0ebc2cdf6bf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fGFxdWFyaXVtfGVufDB8fDB8fHww&auto=format&fit=crop&w=250&q=60)"}}></div>
					</div>
				</div>
				<div className="about_frame"></div>
				<div className="about_frame">
					<div className="about_frame__content about_text-left">
						<h3 className="about_h3" style={{color: 'white'}}>Cosmic Creatures</h3>
						<p style={{fontSize: '2rem', color: 'gray'}}>Delve into the fascinating world of animals and their unique adaptations across our planet, from the depths of oceans to mountaintops.</p>
					</div>
				</div>
				<div className="about_frame about_frame_bg">
					<div className="about_frame__content">
						<div className="about_frame-media about_frame-media_right" style={{backgroundImage: "url(https://images.unsplash.com/photo-1600409396055-e2f42d491271?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fHdpbGQlMjBhbmltYWx8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=250&q=60)"}}></div>
					</div>
				</div>
				<div className="about_frame">
					<div className="about_frame__content">
						<video
                  className="about_frame-media about_frame-media_left lazy-video"
                  data-src="assets/AboutUs/media/video_optimized.mp4"
                  autoPlay
                  loop
                  muted
                ></video>
					</div>
				</div>
				<div className="about_frame"></div>
				<div className="about_frame"></div>
				<div className="about_frame about_frame_bg">
					<div className="about_frame__content">
						<div className="about_frame-media about_frame-media_right" style={{backgroundImage: "url(assets/AboutUs/images/5.webp)"}}></div>
					</div>
				</div>
				<div className="about_frame about_frame_bg">
					<div className="about_frame__content">
						<video
                  className="about_frame-media lazy-video"
                  data-src="assets/AboutUs/media/video_optimized.mp4"
                  autoPlay
                  loop
                  muted
                ></video>
					</div>
				</div>
				<div className="about_frame"></div>
				<div className="about_frame"></div>
				<div className="about_frame">
					<div className="about_frame__content" style={{textAlign: 'center'}}><span>BioUniverse</span><br/>© By Vishal</div>
				</div>
			</section>
		</div>
		<img className="about_soundbutton about_paused" src="assets/AboutUs/images/sound.gif"alt="Alt" onClick={toggleAudio}/>
		<audio className="about_audio" ref={audioRef} src="assets/AboutUs/media/ambient.mp3" loop></audio>
			<AboutHelp/>
	</div>
        </>
    );
}